import { ApiHttpService } from '../ApiHttpService';
import { ConfigParameters } from '../../models/ConfigParameters';
import { ParametersSerializer } from '../serializers/ParametersSerializer';
import { constants } from '../../config';

const PARAMETERS_PATH = 'parametros';

class ParametersController {
  static async all() {
    let url = PARAMETERS_PATH;
    if (constants.refreshConfigParams === 'true') {
      url = `${PARAMETERS_PATH}?timestamp=${new Date().getTime()}`;
    }
    const response = await ApiHttpService.get(url);
    const deSerializedParameters = ParametersSerializer.deSerialize(response.data);
    return new ConfigParameters(deSerializedParameters);
  }
}

export { ParametersController };



// WEBPACK FOOTER //
// ./src/networking/controllers/ParametersController.js